type SummaryCard = {
  key: string;
  label: string;
  value: string | number;
  accentClass: string;
  icon: React.ReactNode;
};

type DashboardStatCardProps = {
  summaryCards: SummaryCard[];
  handleSummaryCardClick: (key: string) => void;
};

const DashboardStatCard = ({
  summaryCards,
  handleSummaryCardClick,
}: DashboardStatCardProps) => {
  return (
    <section className="space-y-3 pt-4">
      <div className="grid grid-cols-3 gap-2">
        {summaryCards.map((card) => (
          <button
            key={card.key}
            type="button"
            onClick={() => handleSummaryCardClick(card.key)}
            className="w-full rounded-[20px] border border-white/80 bg-white px-3 py-3 text-left shadow-[0_10px_28px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(15,23,42,0.10)]"
          >
            <div className="flex items-center gap-2.5">
              <span
                className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-2xl ${card.accentClass}`}
              >
                {card.icon}
              </span>

              <div className="min-w-0 flex-1">
                <p className="text-lg font-bold leading-none text-slate-900">
                  {card.value}
                </p>

                <p className="mt-1.5 whitespace-nowrap text-[9px] font-medium leading-4 text-slate-700 sm:text-xs">
                  {card.label}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default DashboardStatCard;
